import TrustLabel from './TrustLabel';

export default {
  TrustLabel,
};
